import useId from '../utils/useId';
import * as React from 'react';
export const changipaySvg = React.forwardRef(function changipaySvgInner(
  props,
  ref,
) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21.59 14.022s.084-.077.084.057v2.993h-.648v-2.658c0-.027.012-.062.042-.077h-.001c.184-.09.359-.196.523-.316M5.723 15.859l-.018.031c-.279.454-.588.65-1.018.65-.603-.001-1.033-.413-1.034-.985.001-.576.431-.99 1.034-.992.403.002.712.183.935.55l.018.03.543-.349-.022-.03c-.367-.504-.867-.763-1.474-.762-.973.001-1.685.653-1.687 1.553.002.896.715 1.545 1.687 1.547h.002c.66 0 1.192-.301 1.533-.866l.017-.028-.516-.349Zm3.165-1.797v1.078h-1.5v-1.08H6.74v2.97h.647v-1.335h1.501v1.335h.641v-2.97h-.64Zm2.765.868-.414.799-.004.007h.844l-.003-.007-.42-.8-.001-.003-.002.004Zm1.77 2.102h-.67l-.387-.732v-.002H10.95l-.002.002-.375.732h-.67l1.52-2.97h.464l1.51 2.92.027.05Zm2.514-2.97v1.833l-.008-.009-1.747-1.824h-.387v2.969h.641v-1.832l.008.008 1.751 1.824h.383v-2.969h-.641Zm2.95 1.87h.818v.202c-.214.274-.487.405-.85.406-.603 0-1.033-.413-1.034-.985.001-.576.431-.99 1.034-.991.402 0 .712.182.935.549l.018.03.543-.349-.022-.029c-.366-.505-.867-.764-1.474-.764-.973.002-1.685.654-1.686 1.554 0 .896.714 1.546 1.686 1.547.638.001 1.156-.271 1.486-.782l.006-.008v-.937h-1.46v.557Zm4.44 1.164V15.93h.252c.808 0 1.182-.41 1.182-1 0-.694-.56-.909-1.186-.909h-.638v3.074h.39Zm0-1.51V14.37h.35c.393 0 .678.187.678.565 0 .398-.289.65-.784.65h-.244Zm3.338.231c0-.463-.166-.772-.82-.772-.309 0-.54.086-.694.155l.117.268a1.44 1.44 0 0 1 .557-.118c.329 0 .495.162.495.382v.248c-.162-.143-.39-.195-.58-.195-.362 0-.825.19-.825.645 0 .378.272.723.87.723.41 0 .706-.118.88-.268v-1.068Zm-.345.893a.903.903 0 0 1-.512.139c-.345 0-.524-.187-.524-.39s.167-.37.504-.37c.24 0 .426.11.532.203v.418Zm1.129 1.434L29 15.097h-.402l-.678 1.41-.621-1.41H26.9l.828 1.795-.67 1.25h.39Z',
      fill: `url(#bi_changipay__a_${id_0})`,
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_changipay__a_${id_0}`,
          x1: 3,
          y1: 16.072,
          x2: 29,
          y2: 16.072,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.02,
          stopColor: '#50285C',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.26,
          stopColor: '#602762',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.73,
          stopColor: '#8B2573',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#A8247E',
        }),
      ),
    ),
  );
});
changipaySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var changipay = {
  category: 'brand',
  colorable: false,
  name: 'changipay',
  svg: changipaySvg,
};
